// Service d'authentification Bastion pour Parc Info
class BastionAuthService {
  constructor() {
    this.token = null;
    this.user = null;
    // Détecter si on est en mode développement
    this.isDevelopment = this.detectDevelopmentMode();
    this.checkStoredToken();
  }

  // Détecter le mode développement
  detectDevelopmentMode() {
    // En développement, React s'exécute généralement sur localhost:3000
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' ||
                       window.location.hostname.includes('.local');
    
    // Ou vérifier la variable d'environnement React
    const isDev = process.env.NODE_ENV === 'development';
    
    // Ou vérifier si on est sur le port de développement
    const isDevPort = window.location.port === '3000' || window.location.port === '3001';
    
    const developmentMode = isLocalhost || isDev || isDevPort;
    
    if (developmentMode) {
      console.log('🔓 Mode développement détecté - Authentification Bastion désactivée');
    } else {
      console.log('🔒 Mode production - Authentification Bastion activée');
    }
    
    return developmentMode;
  }

  // Vérifier si un token est stocké
  checkStoredToken() {
    this.token = localStorage.getItem('bastionToken');
    if (this.token) {
      try {
        // Décoder le token base64 pour obtenir les infos utilisateur
        this.user = JSON.parse(atob(this.token));
      } catch (e) {
        console.error('Erreur lors du décodage du token:', e);
        this.clearToken();
      }
    }
  }

  // Définir le token
  setToken(token) {
    this.token = token;
    localStorage.setItem('bastionToken', token);
    try {
      this.user = JSON.parse(atob(token));
    } catch (e) {
      console.error('Erreur lors du décodage du token:', e);
    }
  }

  // Récupérer le token
  getToken() {
    if (!this.token) {
      this.token = localStorage.getItem('bastionToken');
    }
    return this.token;
  }

  // Supprimer le token
  clearToken() {
    this.token = null;
    this.user = null;
    localStorage.removeItem('bastionToken');
  }

  // Vérifier si l'utilisateur est authentifié
  isAuthenticated() {
    return !!this.getToken() && !!this.user;
  }

  // Obtenir les headers d'authentification
  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  }

  // Vérifier la validité du token
  async verifyToken() {
    // En mode développement, toujours considérer comme authentifié
    if (this.isDevelopment) {
      console.log('🔓 Mode développement - Authentification automatique');
      // Créer un utilisateur fictif pour le développement
      this.user = {
        username: 'dev-user',
        role: 'admin',
        name: 'Développeur'
      };
      return true;
    }

    if (!this.isAuthenticated()) {
      return false;
    }

    try {
      const response = await fetch('/api/auth/verify', {
        headers: this.getAuthHeaders()
      });

      if (response.ok) {
        const data = await response.json();
        this.user = data.user;
        return true;
      } else {
        this.clearToken();
        return false;
      }
    } catch (error) {
      console.error('Erreur lors de la vérification du token:', error);
      this.clearToken();
      return false;
    }
  }

  // Obtenir les informations de l'utilisateur
  async getCurrentUser() {
    // En mode développement, retourner l'utilisateur fictif
    if (this.isDevelopment) {
      return this.user || {
        username: 'dev-user',
        role: 'admin',
        name: 'Développeur'
      };
    }

    if (this.user) {
      return this.user;
    }

    try {
      const response = await fetch('/api/auth/me', {
        headers: this.getAuthHeaders()
      });

      if (response.ok) {
        const data = await response.json();
        this.user = data.user;
        return this.user;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'utilisateur:', error);
      return null;
    }
  }

logout() {
  this.clearToken();
  
  // En mode développement, ne pas rediriger vers Bastion
  if (this.isDevelopment) {
    console.log('🔓 Mode développement - Rechargement de la page au lieu de redirection Bastion');
    window.location.reload();
  } else {
    window.location.href = 'https://indus.exolis.fr';
  }
}
  // Gérer les erreurs d'authentification
  handleAuthError(error) {
    if (error.status === 401 || error.status === 403) {
      this.clearToken();
      
      // En mode développement, ne pas rediriger vers Bastion
      if (this.isDevelopment) {
        console.log('🔓 Mode développement - Rechargement au lieu de redirection Bastion');
        window.location.reload();
      } else {
        // Rediriger vers le Bastion
        window.location.href = 'https://indus.exolis.fr';
      }
    }
  }
}

export default new BastionAuthService();
